import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Cell = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  min-height: ${space[9]};
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-family: ${fonts.body};
  transition: background-color 0.15s ease;

  &[data-empty] {
    cursor: default;
    pointer-events: none;
  }

  &[data-blocked] {
    cursor: not-allowed;
    pointer-events: none;
  }

  &[data-check-in-closed] {
    background: ${colors.lighterGrey};
  }

  &[data-in-range] {
    background: ${colors.lighterGrey};
  }

  &[data-in-range][data-row-start] {
    border-radius: ${layout.borderRadiusFull} 0 0 ${layout.borderRadiusFull};
  }

  &[data-in-range][data-row-end] {
    border-radius: 0 ${layout.borderRadiusFull} ${layout.borderRadiusFull} 0;
  }

  &[data-range-after] {
    background: linear-gradient(to right, transparent 50%, ${colors.lighterGrey} 50%);
  }

  &[data-range-before] {
    background: linear-gradient(to right, ${colors.lighterGrey} 50%, transparent 50%);
  }
`;

export const DayIndicator = styled.span`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${space[6]};
  min-height: ${space[6]};
  padding: ${space[1]};
  border-radius: ${layout.borderRadiusFull};
  transition: background-color 0.15s ease;

  ${Cell}[data-selected] & {
    background: ${colors.primary};
    color: ${colors.white};
  }

  ${Cell}[data-today]:not([data-selected]) & {
    background: ${colors.lighterGrey};
  }

  ${Cell}[data-hoverable]:hover & {
    background: ${colors.lightGrey};
  }

  ${Cell}[data-selected][data-hoverable]:hover & {
    background: ${colors.primary};
  }
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: 1.2;
  color: ${(p) => (p.$selected ? colors.white : colors.fontPrimary)};

  ${Cell}[data-blocked] & {
    color: ${colors.borderGrey};
  }
`;

export const DayPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? colors.white : colors.fontSecondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
